"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStatsigOnDeviceEvalClient = void 0;
const react_1 = require("react");
const client_core_1 = require("@statsig/client-core");
const NoopEvaluationsClient_1 = require("./NoopEvaluationsClient");
const OnDeviceVsPrecomputedUtils_1 = require("./OnDeviceVsPrecomputedUtils");
const StatsigContext_1 = require("./StatsigContext");
function useStatsigOnDeviceEvalClient() {
    const { client: anyClient, renderVersion } = (0, react_1.useContext)(StatsigContext_1.default);
    const client = (0, react_1.useMemo)(() => {
        if (!(0, OnDeviceVsPrecomputedUtils_1.isPrecomputedEvalClient)(anyClient)) {
            return anyClient;
        }
        client_core_1.Log.warn('Attempting to retrieve a StatsigOnDeviceEvalClient but none was set.');
        return NoopEvaluationsClient_1.NoopEvaluationsClient;
    }, [anyClient, renderVersion]);
    const deps = [client, renderVersion];
    return {
        client,
        checkGate: (0, react_1.useCallback)((name, options) => {
            return client.checkGate(name, options);
        }, deps),
        getFeatureGate: (0, react_1.useCallback)((name, options) => {
            return client.getFeatureGate(name, options);
        }, deps),
        getDynamicConfig: (0, react_1.useCallback)((name, options) => {
            return client.getDynamicConfig(name, options);
        }, deps),
        getExperiment: (0, react_1.useCallback)((name, options) => {
            return client.getExperiment(name, options);
        }, deps),
        getLayer: (0, react_1.useCallback)((name, options) => {
            return client.getLayer(name, options);
        }, deps),
        logEvent: (0, react_1.useCallback)((eventName, user, value, metadata) => {
            if (typeof eventName === 'string') {
                return client.logEvent(eventName, user, value, metadata);
            }
            return client.logEvent(eventName, user);
        }, deps),
    };
}
exports.useStatsigOnDeviceEvalClient = useStatsigOnDeviceEvalClient;
